// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C0A0d"};